import { useEffect, useState } from "react";
import { getData, postData } from "../../helpers/api";
import AddElementLayout from "../layouts/AddElementLayout";
import * as Yup from 'yup';
import SelectInput from "../inputs/SelectInput";
import { Button } from "antd";
import MultipleSelect from "../inputs/MultipleSelect";
import { openNotification } from "../../helpers/alerts";

const AddAccounts = (props) => {
    const [employers, setEmployers] = useState([])
    const [deliveryCompanies, setDeliveryCompanies] = useState([])
    const [deliveryCompaniesAccounts, setDeliveryCompaniesAccounts] = useState([])

    const {
        handleAfterAddingAccounts,
        initialValue,
        isModalOpen,
        handleCancel
    } = props

    const getEmployers = async () => {
        try {
            const res = await getData("/subordinated/noaccounts")
            setEmployers(res.data.map((user) => ({ value: user.id, label: user.name })))
        } catch (error) {
            console.log(error)
        }
    }

    const getDeliveryCompanies = async () => {
        try {
            const res = await getData("/delivery-company")
            setDeliveryCompanies(res.data.filter((el) => el.name !== "Livreur").map((ele) => ({ value: ele.id, label: ele.name })))
        } catch (error) {
            console.log(error)
        }
    }

    const getDeliveryCompaniesKeys = async () => {
        try {
            const res = await getData("/delivery-company-keys")
            setDeliveryCompaniesAccounts(res.data.map((ele) => ({ value: ele.id, label: ele.name })))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getEmployers()
        getDeliveryCompanies()
        getDeliveryCompaniesKeys()
    }, [])

    const addAccounts = async (values, submitProps) => {
        try {
            await postData('/subordinated/accounts', {
                userId: values.userId,
                deliveryCompaniesIds: values.deliveryCompaniesIds,
                deliveryCompanyKeysIds: values.deliveryCompanyKeysIds
            })
            const msg = initialValue.add ? `Le compte a été ajouter avec succès` : `Le compte a été mis a jour avec succès`
            openNotification(msg, 'success')
            submitProps.resetForm()
            handleAfterAddingAccounts()
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }
    return (
        <AddElementLayout
            title={initialValue.edit ? `Mis a jour le Subordonné ${initialValue.subordinatedName}` : "Ajouter un Subordonné"}
            isModalOpen={isModalOpen}
            handleCancel={handleCancel}
            initialValue={initialValue}
            validationSchema={Yup.object({
                userId: Yup.number().required('required'),
                deliveryCompanyKeysIds: Yup.array().required().of(Yup.number()
                    .required('Number is required')
                    .typeError('Must be a number')
                    .integer('Must be an integer')
                    .min(1, 'Number must be at least 1')
                ),
                deliveryCompaniesIds: Yup.array().required().of(Yup.number()
                    .required('Number is required')
                    .typeError('Must be a number')
                    .integer('Must be an integer')
                    .min(1, 'Number must be at least 1')
                ),
            })}
            handleSubmitForm={(values, submitProps) => {
                addAccounts(values, submitProps)
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10
                }}
            >
                {initialValue.add && <SelectInput
                    name="userId"
                    size="large"
                    placeholder="Subordonnés"
                    options={employers}
                />}
                <MultipleSelect
                    name="deliveryCompaniesIds"
                    placeholder="Sociétés"
                    size="large"
                    defaultValue={deliveryCompanies.filter((compnay) => compnay.label === "Livreur").map((company) => company.value)}
                    options={deliveryCompanies}
                />
                <MultipleSelect
                    name="deliveryCompanyKeysIds"
                    placeholder="Comptes"
                    size="large"
                    options={deliveryCompaniesAccounts}
                />
                <Button
                    size='large'
                    type="primary"
                    htmlType="submit"
                >
                    {initialValue.edit ? "Mis a jour" : "Ajouter"}
                </Button>
            </div>
        </AddElementLayout>
    );
}

export default AddAccounts;